/** Channel ids of Slack conversations imported through the API, which exist in no real Slack workspace. */
export const IMPORTED_SLACK_CHANNEL_PREFIX = "C0IMPORT"

export const IMPORTED_SLACK_REPLY_MESSAGE =
	"This conversation was imported, so there is no Slack channel to reply in."

export function isImportedSlackChannel(channelId: string | null | undefined) {
	return !!channelId?.startsWith(IMPORTED_SLACK_CHANNEL_PREFIX)
}
